import {useImperativeHandle, useState} from 'react';
import Swal from 'sweetalert2'

function Search({getDepartaments, setIsSearched, formRef}){
 const [search, setSearch] = useState('')
 const [option, setOption] = useState('')

 useImperativeHandle(formRef, () => ({
        reset: () => {
            setOption('');
            setSearch('');
        }
    })
 );

 const showError = ({message}) => {
    Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: message,
    })
 }
 const handleChangeOption = (e) => {
   setOption(e.target.value)

 }
 const handleChangeSearch = (e) => {
   setSearch(e.target.value)
 }
 const handleSubmit = (e) => {
    e.preventDefault();
    switch(option){
        case "":
            showError({message: 'Seleccione una opción de búsqueda'})
            break;            
        case "codeLogistic":
            if(!search) return showError({message: "Escriba un Código Logístico"});
            getDepartaments({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break
        case "departament":
            if(!search) return showError({message: "Escriba un Departamento"});
            getDepartaments({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break      
        case "town":
            if(!search) return showError({message: "Escriba una Ciudad/Municipio"});
            getDepartaments({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break
        default:
            getDepartaments({})
            break

    }
 }
 return (
 <div>    
  <div className="row mb-2">
   <h6>Busqueda de Departamentos</h6>
  </div>
  <div className="table-responsive rounded-3 d-flex justify-content-center" style={{border:'1px solid black'  , paddingTop:'15px'}}>
        <form className="row g-3" ref={formRef}>
            <div className="col-auto">
                <select onChange={handleChangeOption} className="form-select" aria-label="Default select example" value={option}>
                    <option value="">Seleccione</option>
                    <option value="codeLogistic">Código Logístico</option>
                    <option value="departament">Departamento</option>
                    <option value="town">Municipio</option>
                </select>
            </div>
            <div className="col-auto">
                <input type="text" className="form-control" id="search" name="search" onChange={handleChangeSearch} value={search}/>
            </div>
            <div className="col-auto">
                <button type="submit" className="btn btn-primary mb-3" onClick={handleSubmit}>Buscar</button>
            </div>
        </form> 
    </div>
 </div>
 )
}
export default Search
